"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
var tslib_1 = require("tslib");
var bi_logger_const_1 = require("./bi-logger.const");
var iframe_app_bi_context_1 = require("@wix/iframe-app-bi-context");
function getWebBiLoggerDefaultsConfigForViewer(wixSdkAdapter, widgetName) {
    var _a = prepareConfigParams(wixSdkAdapter), _b = _a.biToken, biToken = _b === void 0 ? '' : _b, _c = _a.businessId, businessId = _c === void 0 ? '' : _c, isOwner = _a.isOwner, isOverEditor = _a.isOverEditor, ownerId = _a.ownerId, _d = _a.uid, uid = _d === void 0 ? '' : _d;
    var sdkWindowJsAdapter = {
        Utils: {
            getInstanceValue: function (key) { return wixSdkAdapter.getInstanceValue(key); },
            getUid: function () { return wixSdkAdapter.getInstanceValue('uid'); },
            getViewMode: function () { return wixSdkAdapter.getViewMode(); },
            getInstanceId: function () { return wixSdkAdapter.getInstanceId(); },
            getSiteOwnerId: function () { return wixSdkAdapter.getOwnerId(); },
        },
    };
    var defaultBiParams = iframe_app_bi_context_1.getBiContext(sdkWindowJsAdapter);
    return tslib_1.__assign({ src: bi_logger_const_1.BI_BOOKINGS_SRC, widget_name: widgetName, businessId: businessId,
        biToken: biToken, is_owner: isOwner, is_over_editor: isOverEditor, visitor_id: uid, ownerId: ownerId, roles: undefined }, defaultBiParams);
}
exports.getWebBiLoggerDefaultsConfigForViewer = getWebBiLoggerDefaultsConfigForViewer;
function prepareConfigParams(wixSdkAdapter) {
    return {
        uid: wixSdkAdapter.getVisitorId(),
        biToken: wixSdkAdapter.getBiToken(),
        businessId: wixSdkAdapter.getInstanceId(),
        isOwner: wixSdkAdapter.isOwner(),
        ownerId: wixSdkAdapter.getOwnerId(),
        isOverEditor: wixSdkAdapter.isEditorMode() || wixSdkAdapter.isPreviewMode(),
    };
}
function getWebBiLoggerDefaultsConfigForEditor(wixSdkAdapter, Wix) {
    var defaultBiParams = iframe_app_bi_context_1.getBiContext(Wix);
    return tslib_1.__assign({ visitor_id: wixSdkAdapter.visitorId, src: 16, businessId: wixSdkAdapter.instanceId, is_over_editor: wixSdkAdapter.isOverEditor, is_owner: wixSdkAdapter.isOwner, biToken: wixSdkAdapter.biToken, contactId: wixSdkAdapter.contactId }, defaultBiParams);
}
exports.getWebBiLoggerDefaultsConfigForEditor = getWebBiLoggerDefaultsConfigForEditor;
//# sourceMappingURL=bookings-bi-defaults.js.map